<div class="formula">
    <div class="texto">
        <b>A({{ formatFormulaVal(item.chacraFactorAAsignado) }})</b> = <span class="color-purple">R({{ formatFormulaVal(item.chacraFactorRAsignado) }})</span> x <span class="color-blue">K({{ formatFormulaVal(item.chacraSueloAsignadoFactorK) }})</span> x <span class="color-blue">L({{ formatFormulaVal(item.chacraFactorLAsignado) }})</span> x <span class="color-blue">S({{ formatFormulaVal(item.chacraFactorSAsignado) }})</span> x <span class="color-blue">P({{ formatFormulaVal(item.chacraFactorP) }})</span> x <span class="color-blue">C({{ formatFormulaVal(item.chacraFactorC) }})</span>
    </div>
</div>
<div class="subtitle-form">
    Los valores de los factores que aparecen por defecto son solamente sugerencias, es necesaria su
    validación en el terreno por el profesional
</div>
<form [formGroup]="form" class="popup-map-form">
    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title> Información  </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="data-form">
                <div class="row field-row">
                    <mat-label class="col">Nombre</mat-label>
                    <mat-form-field appearance="none" class="col">
                        <input formControlName="chacraNombre" matInput [readonly]="!canUpdate()" />
                    </mat-form-field>
                </div>
                <div class="row field-row">
                    <mat-label class="col">Área (ha)</mat-label>
                    <mat-form-field appearance="none" class="col">
                        <input formControlName="chacraArea" matInput readonly />
                    </mat-form-field>
                </div>
                <div class="row field-row">
                    <mat-label class="col">Declarar Terrazas</mat-label>
                    <div class="col d-flex justify-content-end align-items-center">
                        <mat-checkbox formControlName="chacraTerrazas" color="primary" [disabled]="!canUpdate()"></mat-checkbox>
                    </div>
                </div>
                <ng-container *ngIf="chacraTerrazas">
                    <div class="row field-row">
                        <mat-label class="col">Distancia entre terrazas</mat-label>
                        <mat-form-field appearance="none" class="col">
                            <input formControlName="chacraTerrazasLargo" type="number" matInput [readonly]="!canUpdate()" />
                        </mat-form-field>
                    </div>
                    <div class="row field-row">
                        <mat-label class="col">Construidas</mat-label>
                        <div class="col d-flex justify-content-end align-items-center">
                            <mat-checkbox formControlName="chacraTerrazasConstruidas" color="primary" [disabled]="!canUpdate()"></mat-checkbox>
                        </div>
                    </div>
                </ng-container>
            </div>
        </mat-expansion-panel>
        
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title> Pendiente  </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="data-form">
                <div class="row field-row">
                    <mat-label class="col">Porcentaje</mat-label>
                    <mat-form-field appearance="none" class="col">
                        <input formControlName="chacraPendienteAsignado" type="number" min="0" max="100"
                               matInput [readonly]="!pendienteIngresoManual || !canUpdate()" />
                    </mat-form-field>
                </div>
                <div class="row field-row">
                    <mat-label class="col">Largo</mat-label>
                    <mat-form-field appearance="none" class="col">
                        <input formControlName="chacraLargoAsignado" matInput readonly />
                    </mat-form-field>
                </div>
                <div class="row" *ngIf="canUpdate()">
                    <div class="col text-center" *ngIf="!pendienteIngresoManual">
                        <button mat-raised-button color="accent" class="btn-small" (click)="onPendienteManual()">
                            Cálculo Manual
                        </button>
                    </div>
                    <div class="col text-center">
                        <button mat-raised-button color="accent" class="btn-small" (click)="onAddZonaExclusion()">
                            Agregar Parche de Elevación
                        </button>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel
            (opened)="panelPadronesOpenState = true"
            (closed)="panelPadronesOpenState = false"
            *ngIf="!workConfigEnabled()"
        >
            <mat-expansion-panel-header>
                <mat-panel-title>Padrones </mat-panel-title>
                <div class="actions">
                    <button mat-icon-button
                            (click)="$event.stopPropagation();onAddPadron($event)"
                            *ngIf="panelPadronesOpenState && canUpdate()">
                        <fa-icon icon="plus-circle"></fa-icon>
                    </button>
                </div>
            </mat-expansion-panel-header>
            <app-padron-list
                [padrones]="item.padrones"
                [empresas]="empresas"
                (padronesEvent)="padronesChange($event)"
                [canManipulate]="canUpdate()"
            ></app-padron-list>
        </mat-expansion-panel>

        <mat-expansion-panel
            (opened)="panelSuelosOpenState = true"
            (closed)="panelSuelosOpenState = false"
        >
            <mat-expansion-panel-header>
                <mat-panel-title>Suelos </mat-panel-title>
                <div class="actions">
                    <button mat-icon-button
                            (click)="$event.stopPropagation();showAddSuelo = true;"
                            *ngIf="panelSuelosOpenState && !showAddSuelo && item && !item.adjunto && canUpdate()">
                        <fa-icon icon="plus-circle"></fa-icon>
                    </button>
                </div>
            </mat-expansion-panel-header>
            <div class="data-form">
                <div class="row" *ngIf="item.suelos.length === 0 && !showAddSuelo">
                    <div class="col text-center">
                        <p class="warn-color text-center border-danger">
                            El servicio para la obtención los suelos fallo.
                        </p>
                        <button mat-raised-button color="primary" class="btn-small" (click)="getSuelos()" *ngIf="canUpdate()">
                            Obtener Suelos
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="item.suelos.length !== 0 && !showAddSuelo">
                    <mat-form-field appearance="fill" class="col">
                        <mat-label>Seleccionado</mat-label>
                        <mat-select formControlName="chacraSueloAsignadoId" [disabled]="!canUpdate()">
                            <mat-option *ngFor="let s of item.suelos" [value]="s.sueloId">
                                {{s.sueloDesc}} (K = {{s.sueloFactorK}}, T = {{s.sueloTolerancia}})
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                
                <div class="form-box" *ngIf="showAddSuelo">
                    <div class="comment">Ingresar nuevo suelo</div>
                    <app-suelo-form [formInput]="sueloFormInput"
                                    (close)="showAddSuelo = false;"
                                    (addSuelo)="addSuelo($event)">
                    </app-suelo-form>
                </div>

                <a *ngIf="item && item.adjunto" class="page-link" href="{{item.adjunto.adjuntoURL}}" target="_blank">
                    {{item.adjunto.adjuntoNombre}}.{{item.adjunto.adjuntoExtension}}
                </a>
                
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel >
            <mat-expansion-panel-header>
                <mat-panel-title>Factores </mat-panel-title>
            </mat-expansion-panel-header>

            <table class="mat-table mt-3" >
                <tr class="mat-header-row">
                  <th class="mat-header-cell"></th>
                  <th class="mat-header-cell">Elegido</th>
                  <th class="mat-header-cell">Sugerido</th>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">R</td>
                  <td class="mat-cell">{{item.chacraFactorRAsignado}}</td>
                  <td class="mat-cell">{{item.chacraFactorRAutomatico}}</td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">K</td>
                  <td class="mat-cell">{{item.chacraSueloAsignadoFactorK}}</td>
                  <td class="mat-cell">{{item.chacraSueloLimitanteFactorK}}</td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">LS</td>
                  <td class="mat-cell">{{item.chacraFactorLSAsignado}}</td>
                  <td class="mat-cell">{{item.chacraFactorLSLimitante}}</td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">L</td>
                  <td class="mat-cell">{{item.chacraFactorLAsignado}}</td>
                  <td class="mat-cell">{{item.chacraFactorLLimitante}}</td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">L</td>
                  <td class="mat-cell">{{item.chacraFactorSAsignado}}</td>
                  <td class="mat-cell">{{item.chacraFactorSLimitante}}</td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Largo (m)</td>
                  <td class="mat-cell">{{item.chacraLargoAsignado}}</td>
                  <td class="mat-cell">{{item.chacraLargoLimitante}}</td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Pendiente (%)</td>
                  <td class="mat-cell">
                    <button class="btn-small" (click)="calcularPendiente()" *ngIf="canUpdate()"
                            color="primary" mat-raised-button>
                        Recalcular LS
                    </button>
                  </td>
                  <td class="mat-cell">{{formatInPercent(item.chacraPendienteLimitante)}}</td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">P</td>
                  <td class="mat-cell">{{item.chacraFactorP}}</td>
                  <td class="mat-cell"></td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">C</td>
                  <td class="mat-cell">{{item.chacraFactorC}}</td>
                  <td class="mat-cell"></td>
                </tr>
              </table>             

        </mat-expansion-panel>
        
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title> Prácticas Mecánica de Apoyo  </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="data-form">
                <div class="row field-row">
                    <mat-label class="col">Se aplican prácticas</mat-label>
                    <div class="col d-flex justify-content-end align-items-center">
                        <mat-checkbox formControlName="aplicaPractica" color="primary" [disabled]="!canUpdate()"></mat-checkbox>
                    </div>
                </div>
                <div class="row field-row">
                    <mat-label class="col">Práctica</mat-label>
                    <mat-form-field appearance="none" class="col">
                        <mat-select formControlName="mecanicaDeApoyoId" placeholder="Práctica" [disabled]="!canUpdate()">
                            <mat-option *ngFor="let m of mecanicas" [value]="m.mecanicaId">
                                {{m.mecanicaNombre}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row field-row" *ngIf="chacraMecanicaApoyoCoberturaVisible">
                    <mat-label class="col">% cubierto por pastura</mat-label>
                    <mat-form-field appearance="none" class="col">
                        <input formControlName="chacraMecanicaApoyoCobertura" (focusout)="emitChangeCalcFactorP()"
                               max="50" min="0" type="number" placeholder="% cubierto"
                               matInput [readonly]="!canUpdate()" />
                    </mat-form-field>
                </div>
                <div class="row field-row">
                    <mat-label class="col">Factor P</mat-label>
                    <mat-form-field appearance="none" class="col">
                        <input formControlName="chacraFactorP"
                               max="1" min="0" type="number" placeholder="Factor P"
                               matInput [readonly]="!canUpdate()" />
                    </mat-form-field>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>    
</form>

<div class="btn-contenedor mt-3">
    <button (click)="onCancel()" color="warn" mat-raised-button>Cancelar</button>
    <button (click)="onSubmit()" [disabled]="!isFormValid()" mat-raised-button color="primary">
        Actualizar
    </button>
</div>
